import { Link } from "react-router-dom";
import { Mail } from "lucide-react";
import { useLanguage } from "../i18n/LanguageContext";
import { CONTACT_EMAIL } from "../i18n/translations";

const Footer = () => {
  const { t } = useLanguage();
  return (
    <footer
      className="bg-coal-deep text-bone-mute border-t border-line-subtle py-12"
      data-testid="site-footer"
    >
      <div className="max-w-6xl mx-auto px-6 flex flex-col md:flex-row items-center justify-between gap-6 text-xs">
        <div className="flex items-center gap-3">
          <span className="font-display uppercase tracking-wider text-base text-white">
            {t.brand.name}
          </span>
          <span aria-hidden="true">&bull;</span>
          <span>Strength &amp; Technique Coaching</span>
        </div>

        <nav className="flex items-center gap-5" aria-label="Footer navigation">
          <Link to="/about" className="hover:text-gold transition-colors" data-testid="footer-link-about">
            {t.nav.about}
          </Link>
          <Link to="/coaching" className="hover:text-gold transition-colors" data-testid="footer-link-coaching">
            {t.nav.coaching}
          </Link>
          <Link to="/contact" className="hover:text-gold transition-colors" data-testid="footer-link-contact">
            {t.nav.contact}
          </Link>
        </nav>

        <a
          href={`mailto:${CONTACT_EMAIL}`}
          className="inline-flex items-center gap-2 text-bone-soft hover:text-gold transition-colors"
          data-testid="footer-email-link"
        >
          <Mail className="w-3.5 h-3.5" />
          {CONTACT_EMAIL}
        </a>

        <div className="text-center md:text-right">
          <div>{t.footer.led}</div>
          <div className="mt-1">{t.footer.rights}</div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
